import { IRequestFetcherOptions, IParamsOption } from "src/common/razzle-platform-components/types"
import { fetchUser } from "src/common/razzle-platform-user/effects"
import { Store } from 'src/redux'

// we fixed this USER_PROPS_ID for use it to save our props in reudcer
export const USER_PROPS_ID = 'userProps'

// we use this function to get the user on the server side
export async function getInitialPropsOfUser({ route }, store: Store, options: Pick<IParamsOption, 'params'> = {}) {
    try {
        const { id } = route.params;
        const { dispatch, getState } = store

        // in user we need params for make forced request exmaple: parms: { _embed: [user, ...etc]}
		const queryOptions: Pick<IRequestFetcherOptions, 'params'> = {
			params: options.params,
		}

		// get the locale
		const locale: string = getState().translationModel.locale

		// set the Accept-Language to the headers of the request for get the translated data
		const headers = { "Accept-Language": locale }

		// get the user by execute the effect fetchUser and pass it queryOptions
		const { user } = await fetchUser(id, queryOptions, headers)

        // save the initialProps in the reducer
		dispatch.ssrModel.setInitialProps({ [USER_PROPS_ID]: { user, queryOptions } })

    } catch (error) {
        console.log('mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm', error)
    }
}
